import { COLORS, SHAPE_STYLES, TEXT_STYLE } from '../constants';
import { changeTextObjectText, createAndAddLocalTextObject } from '../textobject/textobject';
import {
  addGameObject,
  anchoredPos,
  createTransformFullSizeAnimation,
  getZeroStaticEntity,
  setParent,
} from '../entity';
import {
  cloneShapeStyle,
  Ease,
  hasVisibleState,
  noAutoResize,
  removeDenseArrayIndex,
  v2,
} from '../helpers';
import {
  BreakoutLobbyState,
  ServerEvent_EntityProps,
  ServerEvent_BreakoutController,
  BreakoutGroupData,
  JSON_BreakoutGroupAction,
  EventClientToServer,
  BreakoutClientData as BreakoutUser,
  BreakoutGroupStatus,
  BreakoutClientStatus,
  type BreakoutClientData,
} from '../shared/api_shared_types';
import { setVisibilityState, setParentByEntityProps } from '../simulate';
import {
  Entity,
  VisibilityState,
  GameManager,
  BreakoutController,
  MoveMode,
  Shape,
  SharedObjectType,
  GroupListItem,
  GameObjectController,
  type CollectionListItem,
  TextAppearStyle,
  type TextObject,
  type TextButton,
  type TextObjectStyle,
  type RenderShapeStyle,
  type Canvas,
  type BreakoutUserView,
  type UsersListItem,
  type IconButton,
  type ButtonStyle,
  type TransformFullSize,
} from '../types';
import { createAndAddLocalTextButton, setTextbuttonStyle } from '../textbutton';
import { createAndAddLocalContainer, setContainerStyle, setContainerStyles } from '../container';
import logger from '../controllers/logger';
import { createAndAddLocalCanvas, setCanvasLayerSize } from '../canvas';
import { createAndAddLocalIconButton } from '../icon_button';
import * as constants from './breakout_controller_constants';
import { t } from '../localizationController';

export function controller(): GameObjectController {
  return {
    getNew: getZeroBreakoutController,
    sync,
    update,
  };
}

export function getZeroBreakoutController(ent: Entity): BreakoutController {
  let newNode: BreakoutController = {
    ...ent,
    objectType: SharedObjectType.BREAKOUT_CONTROLLER,

    slug: '',
    info: '',
    stopTimer: -1,
    totalMissionSteps: 0,

    usersWithoutGroup: [],
    groupData: [],

    usersNotIngroupItem: null,
    collectionListItems: [],
    groupListItems: [],

    stickToScreen: false,

    container: null,
    groupCanvas: null,
    readyCollectionData: null,
    startedCollectionData: null,
    notStartedCollectionData: null,
    emptyCollectionData: null,
    finishedCollectionData: null,
    btnStartAllReady: null,
    btnStopMenu: null,
    btnStopAll: null,
    btnStopAllTimed: null,
    btnCreateGroups: null,

    lobbyStateContainer: null,
    btnState_preOpen: null,
    btnState_Matching: null,
    btnState_Closed: null,
    btnState_Closed_Problem: null,

    tObjInfo: null,
    tObjNotInGroup: null,
    tObjNotReady: null,
  };

  return newNode;
}
function sync(
  manager: GameManager,
  breakoutController: BreakoutController,
  props: ServerEvent_BreakoutController,
) {
  let entityProps: ServerEvent_EntityProps = {};

  if (props.hasOwnProperty('entityProps')) {
    entityProps = props.entityProps;
  }

  let updateText = false;

  if (props.hasOwnProperty('sequenceSlug')) {
    breakoutController.slug = props.sequenceSlug;
    updateText = true;
  }

  if (props.hasOwnProperty('info')) {
    breakoutController.info = props.info;
    updateText = true;
  }

  if (props.hasOwnProperty('stickToScreen')) {
    breakoutController.stickToScreen = props.stickToScreen;
  }

  if (props.hasOwnProperty('stopTimer')) {
    breakoutController.stopTimer = props.stopTimer;
    updateStopTimer(breakoutController);
  }

  if (updateText) {
    updateInfoText(breakoutController, getInfoText(breakoutController));
  }

  if (!breakoutController.id) {
    addGameObject(manager, breakoutController);
    init(manager, breakoutController);
    setParentByEntityProps(manager, breakoutController, props.sId, props.roomId, entityProps);
  }

  // setGameObjectyEntityProps(breakoutController, entityProps);

  let doUpdateGroupData = false;

  if (props.hasOwnProperty('readyGroupInfo')) {
    breakoutController.readyCollectionData = props.readyGroupInfo;
    doUpdateGroupData = true;
  }

  if (props.hasOwnProperty('notStartedGroupInfo')) {
    breakoutController.notStartedCollectionData = props.notStartedGroupInfo;
    doUpdateGroupData = true;
  }

  if (props.hasOwnProperty('totalSteps')) {
    breakoutController.totalMissionSteps = props.totalSteps;
  }

  if (props.hasOwnProperty('startedGroupInfo')) {
    breakoutController.startedCollectionData = props.startedGroupInfo;
    doUpdateGroupData = true;
  }

  if (props.hasOwnProperty('emptyGroupInfo')) {
    breakoutController.emptyCollectionData = props.emptyGroupInfo;
    doUpdateGroupData = true;
  }

  if (props.hasOwnProperty('finishedGroupInfo')) {
    breakoutController.finishedCollectionData = props.finishedGroupInfo;
    doUpdateGroupData = true;
  }

  if (props.hasOwnProperty('groupData')) {
    breakoutController.groupData = props.groupData;
    doUpdateGroupData = true;
  }

  if (props.hasOwnProperty('clientsWithoutGroup')) {
    breakoutController.usersWithoutGroup = props.clientsWithoutGroup;
    doUpdateGroupData = true;
  }

  if (props.hasOwnProperty('lobbyState')) {
    setLobbyState(breakoutController, props.lobbyState);
  }

  if (doUpdateGroupData) {
    updateGroupData(breakoutController);
  }
}

function init(manager: GameManager, baController: BreakoutController) {
  baController.shape = Shape.RECT;

  if (baController.stickToScreen) {
    baController.relativeHeight = 1;
  } else {
    baController.height = constants.HEIGHT;
  }
  baController.width = constants.WIDTH;

  baController.moveMode = MoveMode.STATIC;
  baController.allowDrag = !baController.stickToScreen;
  baController.anchoredPos.relativePivotPos = v2(0.5, 0);

  //container
  {
    const c = createAndAddLocalContainer(manager, getZeroStaticEntity());
    c.width = constants.WIDTH;
    if (baController.stickToScreen) {
      c.relativeHeight = 1;
    } else {
      c.height = constants.HEIGHT;
    }
    c.allowHighlight = true;
    c.passHover = true;
    c.allowDrag = false;
    c.passDrag = true;
    c.cornerRadius = 20;
    baController.container = c;
    setContainerStyle(c, SHAPE_STYLES.BREAKOUT_CONTROLLER.BACKGROUND);
    c.moveMode = MoveMode.ANCHORED;

    c.anchoredPos = anchoredPos(v2(0.5, 0), v2(), v2(0.5, 0));
    setParent(c, baController, v2());
  }

  //scroll canvas
  {
    const PADDING_TOP = 185;
    const PADDING_BOTTOM = 20;

    const props: Partial<Canvas> = {
      minLayerWidth: 530,
      minLayerHeight: 1000,
      listMode: true,
    };
    const c = createAndAddLocalCanvas(manager, getZeroStaticEntity(), props);
    c.relativeWidth = 1;
    c.padWidth = -2;
    if (baController.stickToScreen) {
      c.relativeHeight = 1;
      c.padHeight = -PADDING_TOP - PADDING_BOTTOM;
    } else {
      c.height = constants.HEIGHT - PADDING_TOP - PADDING_BOTTOM;
    }

    c.moveMode = MoveMode.ANCHORED;
    c.anchoredPos = anchoredPos(v2(0.5, 0), v2(0, PADDING_TOP), v2(0.5, 0));
    // c.debugView = true;
    c.allowZoom = false;
    c.allowScrollVert = true;
    c.doClipChildren = true;
    c.allowHighlight = true;
    c.debug = 'canvas baController - ' + baController.stickToScreen.toString();

    setContainerStyle(c.layer, SHAPE_STYLES.UI_GREY);
    setParent(c, baController.container);

    baController.groupCanvas = c;
  }

  //label
  {
    const text = getInfoText(baController);

    const tObjInfo = createAndAddLocalTextObject(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      text,
      constants.TEXT_BREAKOUT_CONTROLLER_INFO,
      4.5,
      false,
    );

    tObjInfo.moveMode = MoveMode.ANCHORED;
    tObjInfo.anchoredPos = anchoredPos(v2(0, 0), v2(20, 20), v2(0, 0));
    baController.tObjInfo = tObjInfo;
    setParent(tObjInfo, baController.container);
  }

  //create Groups button
  {
    const btn = createAndAddLocalTextButton(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      'Create groups',
      'iconUsers',
      TEXT_STYLE.BUTTON_FIXED,
      1.57,0,0,0.42
    );
    btn.moveMode = MoveMode.ANCHORED;
    btn.disableAutoSize = true;
    btn.animType = 'zoom';

    btn.anchoredPos = anchoredPos(v2(0, 0), v2(20, 85), v2(0, 0));

    setParent(btn, baController.container);
    baController.btnCreateGroups = btn;

    setVisibilityState(btn, VisibilityState.APPEARING);
  }

  //start all button
  {
    const btn = createAndAddLocalTextButton(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      'Start ready groups',
      'iconPlay',
      TEXT_STYLE.BUTTON_FIXED_GREEN,
      1.57,0,0,0.42
    );
    btn.moveMode = MoveMode.ANCHORED;
    btn.disableAutoSize = true;

    btn.anchoredPos = anchoredPos(v2(0, 0), v2(20, 130), v2(0, 0));

    setParent(btn, baController.container);
    baController.btnStartAllReady = btn;
    setVisibilityState(btn, VisibilityState.APPEARING);
  }

  //lobbystate container
  {
    const c = createAndAddLocalContainer(manager, getZeroStaticEntity());
    c.width = 4 * 62;

    c.height = 36;

    c.allowHighlight = false;
    c.passHover = true;
    c.doClipChildren = true;

    c.cornerRadius = 20;
    baController.lobbyStateContainer = c;
    setContainerStyle(c, constants.LOBBY_STATE_TOGGLE);
    c.moveMode = MoveMode.ANCHORED;

    c.anchoredPos = anchoredPos(v2(0, 0), v2(190, 85), v2(0, 0));
    setParent(c, baController, v2());
  }

  //set state pre-open
  {
    const btn = createAndAddLocalTextButton(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      'pre',
      '',
      TEXT_STYLE.BUTTON_FIXED,
      0.6,
      0.5,
      0,
      0.3,
    );
    btn.moveMode = MoveMode.ANCHORED;
    btn.disableAutoSize = true;

    btn.anchoredPos = anchoredPos(v2(0, 0.5), v2(0, 0), v2(0, 0.5));
    btn.animType = 'zoom';

    setParent(btn, baController.lobbyStateContainer);
    baController.btnState_preOpen = btn;
    setVisibilityState(btn, VisibilityState.APPEARING);
  }
  //set state  matching
  {
    const btn = createAndAddLocalTextButton(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      'open',
      '',
      TEXT_STYLE.BUTTON_FIXED,
      0.6,
      0.5,
      0,
      0.3,
    );
    btn.moveMode = MoveMode.ANCHORED;
    btn.disableAutoSize = true;

    btn.anchoredPos = anchoredPos(v2(0.25, 0.5), v2(0, 0), v2(0, 0.5));
    btn.animType = 'zoom';

    setParent(btn, baController.lobbyStateContainer);
    baController.btnState_Matching = btn;
    setVisibilityState(btn, VisibilityState.APPEARING);
  }

  //set state closed
  {
    const btn = createAndAddLocalTextButton(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      'closed',
      '',
      TEXT_STYLE.BUTTON_FIXED,
      0.6,
      0.5,
      0,
      0.3,
    );
    btn.moveMode = MoveMode.ANCHORED;
    btn.disableAutoSize = true;

    btn.anchoredPos = anchoredPos(v2(0.5, 0.5), v2(0, 0), v2(0, 0.5));
    btn.animType = 'zoom';

    setParent(btn, baController.lobbyStateContainer);
    baController.btnState_Closed = btn;
    setVisibilityState(btn, VisibilityState.APPEARING);
  }

  //set state closed problem
  {
    const btn = createAndAddLocalTextButton(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      'Problem',
      '',
      constants.LOBBY_STATE_BTN_TEXT,
      0.6,
      0.5,
      0,
      0.3,
    );
    btn.moveMode = MoveMode.ANCHORED;
    btn.disableAutoSize = true;

    btn.anchoredPos = anchoredPos(v2(0.75, 0.5), v2(0, 0), v2(0, 0.5));
    btn.animType = 'zoom';

    setParent(btn, baController.lobbyStateContainer);
    baController.btnState_Closed_Problem = btn;
    setVisibilityState(btn, VisibilityState.APPEARING);
  }

  //stop all button
  {
    const btn = createAndAddLocalTextButton(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      'Stop all',
      'iconQuit',
      TEXT_STYLE.BUTTON_FIXED_RED_DARK,
      1.0,
      1,
      5,0.55
    );
    btn.moveMode = MoveMode.ANCHORED;
    btn.disableAutoSize = true;

    btn.anchoredPos = anchoredPos(v2(0, 0), v2(190, 130), v2(0, 0));
    btn.animType = 'zoom';

    setParent(btn, baController.container);
    baController.btnStopAll = btn;
    setVisibilityState(btn, VisibilityState.APPEARING);
  }

  //stop all in 3 min button
  {
    const btn = createAndAddLocalTextButton(
      manager,
      getZeroStaticEntity({ disableAutoSize: true }),
      'Stop all in 3m',
      'iconTimer',
      TEXT_STYLE.BUTTON_FIXED_RED_DARK,
      1.0,
      1,
      5,0.55
    );
    btn.moveMode = MoveMode.ANCHORED;
    btn.disableAutoSize = true;
    btn.animType = 'zoom';

    btn.anchoredPos = anchoredPos(v2(0, 0), v2(300, 130), v2(0, 0));

    setParent(btn, baController.container);
    baController.btnStopAllTimed = btn;
    setVisibilityState(btn, VisibilityState.APPEARING);
  }

  setVisibilityState(baController, VisibilityState.APPEARING);
}

function getInfoText(breakoutRoom: BreakoutController): string {
  let info = `${breakoutRoom.info}`;

  return info;
}

function updateInfoText(breakoutRoom: BreakoutController, text: string) {
  if (breakoutRoom.tObjInfo) {
    changeTextObjectText(breakoutRoom.tObjInfo, text);
  }
}

function update(breakoutController: BreakoutController): boolean {
  checkButtonInteraction(breakoutController);

  if (breakoutController.usersNotIngroupItem) {
    const userViews = breakoutController.usersNotIngroupItem.userViews;
    for (let i = userViews.length - 1; i >= 0; i--) {
      const userView = userViews[i];
      const actionData = updateUserViews(userView, false, false, false);
      if (actionData) {
        actionData.sId = breakoutController.serverObjId;
        break;
      }
    }
  }

  for (let i = breakoutController.groupListItems.length - 1; i >= 0; i--) {
    const group = breakoutController.groupListItems[i];

    const actionData = updateGroupListItem(group);
    if (actionData) {
      actionData.sId = breakoutController.serverObjId;
    }
  }

  return false;
}

function updateGroupData(breakoutController: BreakoutController) {
  const PADDING_Y = 8;
  let y = PADDING_Y;

  {
    const height = upsertUsersListItem(breakoutController, breakoutController.usersWithoutGroup, y);
    y += height + PADDING_Y;
  }

  //GROUP COLLECTIONS
  {
    const type = 'ready';
    const collectionData = breakoutController.readyCollectionData;
    const height = upsertGroupCollection(breakoutController, type, collectionData, y);
    if (height) {
      y += height + PADDING_Y;
    }
  }
  {
    const type = 'not_started';
    const collectionData = breakoutController.notStartedCollectionData;
    const height = upsertGroupCollection(breakoutController, type, collectionData, y);
    if (height) {
      y += height + PADDING_Y;
    }
  }
  {
    const type = 'started';
    const collectionData = breakoutController.startedCollectionData;
    const height = upsertGroupCollection(breakoutController, type, collectionData, y);
    if (height) {
      y += height + PADDING_Y;
    }
  }
  {
    const type = 'empty';
    const collectionData = breakoutController.emptyCollectionData;
    const height = upsertGroupCollection(breakoutController, type, collectionData, y);
    if (height) {
      y += height + PADDING_Y;
    }
  }
  {
    const type = 'finished';
    const collectionData = breakoutController.finishedCollectionData;
    const height = upsertGroupCollection(breakoutController, type, collectionData, y);
    if (height) {
      y += height + PADDING_Y;
    }
  }

  //sort the groupdata for priority
  breakoutController.groupData.sort(sortGroupData);

  for (let i = 0; i < breakoutController.groupData.length; i++) {
    const groupData = breakoutController.groupData[i];

    const height = upsertBreakoutListItem(breakoutController, groupData, y);

    if (height) {
      y += height + PADDING_Y;
    }
  }

  //remove groups that do not exist anymore
  for (let i = breakoutController.groupListItems.length - 1; i >= 0; i--) {
    const id = breakoutController.groupListItems[i].id;

    const idExists = breakoutController.groupData.some((it) => it.groupId === id);
    if (!idExists) {
      setVisibilityState(
        breakoutController.groupListItems[i].container,
        VisibilityState.DISAPPEARING,
      );
      removeDenseArrayIndex(breakoutController.groupListItems, i);
    }
  }

  const scrollCanvasHeight = Math.max(y);

  setCanvasLayerSize(breakoutController.groupCanvas, 530, scrollCanvasHeight);

  breakoutController.height = breakoutController.container.height;
  breakoutController.container.layoutChanged = true;
}

function createGroupCollection(
  manager: GameManager,
  type: 'ready' | 'started' | 'empty' | 'finished' | 'not_started',
  collectionData: { count: number; users: number },
): CollectionListItem {
  const container = createAndAddLocalContainer(manager, getZeroStaticEntity());
  container.width = 520;
  container.height = 100;
  container.cornerRadius1 = 0;
  container.cornerRadius2 = 20;
  container.cornerRadius3 = 20;
  container.cornerRadius4 = 0;

  container.appearDuration = 0;
  container.disappearDuration = 0;

  let text = `${collectionData.count} groups, ${collectionData.users} users - `;

  switch (type) {
    case 'ready':
      setContainerStyles(container, constants.SHAPE_GROUP_DEFAULT, constants.SHAPE_GROUP_DEFAULT_HL);
      text += 'ready';
      break;
    case 'started':
      setContainerStyles(container, constants.SHAPE_GROUP_ACTIVE, constants.SHAPE_GROUP_ACTIVE_HL);
      text += 'active';
      break;
    case 'finished':
      setContainerStyles(container, constants.SHAPE_GROUP_ACTIVE, constants.SHAPE_GROUP_ACTIVE_HL);
      text += 'finished';
      break;
    case 'not_started':
      setContainerStyles(container, constants.SHAPE_GROUP_ACTIVE, constants.SHAPE_GROUP_ACTIVE_HL);
      text += 'active (not started)';
      break;
    case 'empty':
      setContainerStyles(container, constants.SHAPE_GROUP_WARNING, constants.SHAPE_GROUP_WARNING_HL);
      text += 'empty';
      break;
    default:
      setContainerStyles(container, constants.SHAPE_GROUP_DEFAULT, constants.SHAPE_GROUP_DEFAULT_HL);
  }

  const tObj = createAndAddLocalTextObject(
    manager,
    getZeroStaticEntity(),
    text,
    noAutoResize(constants.TEXT_GROUP_STATUS),
    5,
    false,
    0,
    1,
    TextAppearStyle.NONE,
  );

  tObj.moveMode = MoveMode.ANCHORED;
  tObj.appearDuration = 0;
  tObj.disappearDuration = 0;

  const MARGIN_X = 20;
  const MARGIN_Y = 20;

  tObj.anchoredPos = anchoredPos(v2(0, 0), v2(MARGIN_X, MARGIN_Y), v2(0, 0));
  setParent(tObj, container);

  const newGroupCollection: CollectionListItem = {
    container,
    tObjTitle: null,
    tObjGroupInfo: null,
    tObj,
    btnStart: null,
    btnStop: null,
    type: type,
    data: {
      groupId: 0,
      started: false,
      isReady: false,
      isFinished: false,
      statusString: '',
      canJoin: false,
      canLeave: false,
      clients: [],
      activeStep: 0,
      activeRound: 0,
      status: BreakoutGroupStatus.NONE,
      userGroupName: '',
    },
  };

  container.height = tObj.height + MARGIN_Y + MARGIN_Y;

  return newGroupCollection;
}

function updateGroupCollection(
  collection: CollectionListItem,
  collectionData: { count: number; users: number },
) {
  let text = `${collectionData.count} groups, ${collectionData.users} users - `;

  switch (collection.type) {
    case 'ready':
      text += 'ready';
      break;
    case 'started':
      text += 'active';
      break;
    case 'finished':
      text += 'finished';
      break;
    case 'not_started':
      text += 'active (not started)';
      break;
    case 'empty':
      text += 'all left';
      break;
    default:
  }

  const MARGIN_X = 20;
  const MARGIN_Y = 20;

  changeTextObjectText(collection.tObj, text, true);
  collection.container.height = collection.tObj.height + MARGIN_Y + MARGIN_Y;
}

function createBreakoutListItem(manager: GameManager, data: BreakoutGroupData): GroupListItem {
  const container = createAndAddLocalContainer(manager, getZeroStaticEntity());
  container.width = 520;
  container.height = constants.MIN_GROUP_HEIGHT;
  container.appearDuration = 0;
  container.disappearDuration = 0;
  container.allowHighlight = true;
  container.cornerRadius1 = 0;
  container.cornerRadius2 = 20;
  container.cornerRadius3 = 20;
  container.cornerRadius4 = 20;
  container.passHover = true;
  container.clickable = false;

  const statusBar = createAndAddLocalContainer(manager, getZeroStaticEntity());
  statusBar.relativeWidth = 1;
  statusBar.height = 33;
  statusBar.appearDuration = 0;
  statusBar.disappearDuration = 0;
  statusBar.cornerRadius1 = 0;
  statusBar.cornerRadius2 = 20;
  statusBar.cornerRadius3 = 0;
  statusBar.cornerRadius4 = 0;
  setContainerStyle(statusBar, SHAPE_STYLES.NONE);

  statusBar.moveMode = MoveMode.ANCHORED;
  statusBar.anchoredPos = anchoredPos(v2(0, 0), v2(0, 0), v2(0, 0));
  setParent(statusBar, container);

  const tObjTitle = createAndAddLocalTextObject(
    manager,
    getZeroStaticEntity(),
    data.groupId.toString(),
    constants.TEXT_GROUP_TITLE,
    3.5,
    false,
  );

  tObjTitle.appearDuration = 0;
  tObjTitle.disappearDuration = 0;

  tObjTitle.moveMode = MoveMode.ANCHORED;
  tObjTitle.anchoredPos = anchoredPos(v2(0, 0), v2(5, 5), v2(0, 0));
  setParent(tObjTitle, container);

  const tObjStatus = createAndAddLocalTextObject(
    manager,
    getZeroStaticEntity(),
    data.groupId.toString(),
    noAutoResize(constants.TEXT_GROUP_STATUS),
    3.5,
    false,
  );

  tObjStatus.moveMode = MoveMode.ANCHORED;
  tObjStatus.appearDuration = 0;
  tObjStatus.disappearDuration = 0;

  tObjStatus.anchoredPos = anchoredPos(v2(0, 0), v2(44, 7), v2(0, 0));
  setParent(tObjStatus, container);

  let tObjUserGroup: TextObject = null;

  tObjUserGroup = createAndAddLocalTextObject(
    manager,
    getZeroStaticEntity(),
    data.userGroupName || '',
    noAutoResize(constants.TEXT_USER_GROUP_NAME),
    3.5,
    false,
  );

  tObjUserGroup.moveMode = MoveMode.ANCHORED;
  tObjUserGroup.appearDuration = 0;
  tObjUserGroup.disappearDuration = 0;

  tObjUserGroup.anchoredPos = anchoredPos(v2(0, 0), v2(10, 26), v2(0, 0));
  setParent(tObjUserGroup, container);

  if (!data.userGroupName) {
    setVisibilityState(tObjUserGroup, VisibilityState.HIDDEN);
  }

  const tObjStep = createAndAddLocalTextObject(
    manager,
    getZeroStaticEntity(),
    data.groupId.toString(),
    noAutoResize(constants.TEXT_GROUP_STEP),
    3.5,
    false,
  );

  tObjStep.moveMode = MoveMode.ANCHORED;
  tObjStep.appearDuration = 0;
  tObjStep.disappearDuration = 0;

  tObjStep.anchoredPos = anchoredPos(v2(1, 0), v2(-5, 5), v2(1, 0));
  setParent(tObjStep, container);

  const newGroup: GroupListItem = {
    id: data.groupId,
    data,
    container,
    statusBar,
    tObjTitle,
    tObjStatus,
    tObjStep,
    tObjUserGroup,
    userViews: [],
    btnStart: null,
    btnStop: null,
    btnJoin: null,
    btnLeave: null,
    btnContinue: null,
    btnUngroup: null,
  };

  return newGroup;
}

function upsertUsersListItem(
  breakoutController: BreakoutController,
  groupData: BreakoutClientData[],
  y: number,
): number {
  let usersNotIngroupItem: UsersListItem = breakoutController.usersNotIngroupItem;

  if (groupData.length) {
    if (!usersNotIngroupItem) {
      usersNotIngroupItem = createUsersListItem(breakoutController.manager, groupData);
      usersNotIngroupItem.container.moveMode = MoveMode.ANCHORED;
      breakoutController.usersNotIngroupItem = usersNotIngroupItem;
      breakoutController.groupCanvas.attachChild(
        usersNotIngroupItem.container,
        breakoutController.groupCanvas,
      );
    }

    const height = updateUsersListItem(usersNotIngroupItem, groupData) + 20;

    usersNotIngroupItem.container.anchoredPos = anchoredPos(v2(0, 0), v2(5, y), v2(0, 0));

    const fullSizeTo: TransformFullSize = {
      width: 520,
      height: height,
      relativeWidth: 0,
      relativeHeight: 0,
      padHeight: 0,
      padWidth: 0,
      maxWidth: 0,
      maxHeight: 0,
      maxAspect: 0,
    };

    createTransformFullSizeAnimation(breakoutController.manager, usersNotIngroupItem.container, {
      end: fullSizeTo,
      duration: 0.5,
      easeFunction: Ease.inOutCubic,
    });

    return height;
  } else if (usersNotIngroupItem) {
    setVisibilityState(usersNotIngroupItem.container, VisibilityState.DISAPPEARING);

    breakoutController.usersNotIngroupItem = null;
  }
  return 0;
}

function createUsersListItem(manager: GameManager, data: BreakoutClientData[]): UsersListItem {
  const container = createAndAddLocalContainer(manager, getZeroStaticEntity());
  container.width = 520;
  container.height = 10;
  container.appearDuration = 0;
  container.disappearDuration = 0;
  container.allowHighlight = true;
  container.cornerRadius1 = 0;
  container.cornerRadius2 = 20;
  container.cornerRadius3 = 20;
  container.cornerRadius4 = 20;
  container.passHover = true;
  container.clickable = false;

  setContainerStyles(container, constants.SHAPE_GROUP_USERS, constants.SHAPE_GROUP_USERS_HL);

  const tObjTitle = createAndAddLocalTextObject(
    manager,
    getZeroStaticEntity(),
    'Users',
    constants.TEXT_CATEGORY_TITLE,
    3.5,
    false,
  );

  tObjTitle.appearDuration = 0;
  tObjTitle.disappearDuration = 0;

  tObjTitle.moveMode = MoveMode.ANCHORED;
  tObjTitle.anchoredPos = anchoredPos(v2(0, 0), v2(6, 6), v2(0, 0));
  setParent(tObjTitle, container);

  const newGroup: UsersListItem = {
    container,
    tObjTitle,
    tObjUserGroup: null,
    userViews: [],
  };

  return newGroup;
}

function updateUsersListItem(listItem: UsersListItem, data: BreakoutClientData[]): number {
  const manager = listItem.container.manager;

  const MARGIN = 10;
  let posY = 40 + MARGIN;

  const joiningCount = data.filter(
    (it) => it.status === BreakoutClientStatus.IN_PLENARY_JOINING,
  ).length;
  const readyCount = data.length - joiningCount;

  let titleReady = '';
  if (readyCount === 1) {
    titleReady = `1 user ready`;
  } else if (readyCount > 1) {
    titleReady = `${readyCount} users ready`;
  }
  let titleJoining = '';
  if (joiningCount === 1) {
    titleJoining = ` (1 joining)`;
  } else if (joiningCount > 1) {
    titleJoining = ` (${joiningCount} joining)`;
  }

  const title = `${titleReady}${titleJoining}`;

  changeTextObjectText(listItem.tObjTitle, title);

  const doHideUsers = data.length > 5;

  if (!doHideUsers) {
    for (let i = 0; i < data.length; i++) {
      const userData = data[i];

      let userView: BreakoutUserView = listItem.userViews.find((it) => it.id === userData.id);

      if (!userView) {
        userView = createBreakoutUserView(manager, userData);
        listItem.userViews.push(userView);
        setParent(userView.container, listItem.container);
      }

      updateUserView(userView, userData, posY, false, false);
      posY += userView.container.height + MARGIN;
    }
  }

  //remove userViews that do not exist anymore
  for (let i = listItem.userViews.length - 1; i >= 0; i--) {
    const id = listItem.userViews[i].id;
    const idExists = data.find((it) => it.id === id);
    if (!idExists || doHideUsers) {
      setVisibilityState(listItem.userViews[i].container, VisibilityState.DISAPPEARING);
      removeDenseArrayIndex(listItem.userViews, i);
    }
  }

  return posY;
}

function updateStopTimer(breakoutController: BreakoutController) {
  if (breakoutController.btnStopAllTimed) {
    const label =
      breakoutController.stopTimer > 0
        ? t('breakout.cancel_stop', { seconds: breakoutController.stopTimer })
        : t('breakout.stop_all');

    changeTextObjectText(breakoutController.btnStopAllTimed.textObject, label);
  }
}

function getUserStatusString(it: BreakoutUser, started: boolean, finished: boolean): string {
  const hideStatus =
    it.status === BreakoutClientStatus.NONE ||
    (it.status === BreakoutClientStatus.IN_PLENARY && !started) ||
    (it.status === BreakoutClientStatus.IN_BREAKOUT_ROOM && (started || finished));

  let status: string = it.status;

  if (it.status === BreakoutClientStatus.IN_PLENARY) {
    status = t('breakout.status_in_plenary');
  } else if (it.status === BreakoutClientStatus.IN_PLENARY_JOINING) {
    status = t('breakout.status_joining_plenary');
  } else if (it.status === BreakoutClientStatus.IN_BREAKOUT_ROOM) {
    status = t('breakout.status_in_breakout');
  } else if (it.status === BreakoutClientStatus.IN_BREAKOUT_ROOM_JOINING) {
    status = t('breakout.status_joining_breakout');
  }

  status = hideStatus ? '' : ` ${status}`;

  const isYou = it.isYou ? ' ' + t('breakout.status_you') : '';
  return `${isYou}${status}`;
}

function getUserViewStyle(
  it: BreakoutUser,
  started: boolean,
  finished: boolean,
): { shape: RenderShapeStyle; status: TextObjectStyle } {
  const hideStatus =
    it.status === BreakoutClientStatus.NONE ||
    (it.status === BreakoutClientStatus.IN_PLENARY && !started) ||
    (it.status === BreakoutClientStatus.IN_BREAKOUT_ROOM && (started || finished));
  // const STATUS = constants.TEXT_USER_STATUS;

  let status: TextObjectStyle = constants.TEXT_USER_STATUS;
  let shape: RenderShapeStyle = constants.SHAPE_USER_DEFAULT;

  if (it.isYou) {
    status = constants.TEXT_USER_STATUS_YOU;
  } else if (it.status === BreakoutClientStatus.IN_PLENARY) {
    if (started) {
      status = constants.TEXT_USER_STATUS_WARNING;
      shape = constants.SHAPE_USER_WARNING;
    }
  } else if (it.status === BreakoutClientStatus.IN_PLENARY_JOINING) {
    if (started) {
      status = constants.TEXT_USER_STATUS_WARNING;
      shape = constants.SHAPE_USER_WARNING;
    }
  } else if (it.status === BreakoutClientStatus.IN_BREAKOUT_ROOM) {
    if (started && !finished) {
      status = constants.TEXT_USER_STATUS;
    }
  } else if (it.status === BreakoutClientStatus.IN_BREAKOUT_ROOM_JOINING) {
    status = constants.TEXT_USER_STATUS;
  } else if (
    it.status === BreakoutClientStatus.DISCONNECTED ||
    it.status === BreakoutClientStatus.OFFLINE
  ) {
    status = constants.TEXT_USER_STATUS_WARNING;
    shape = constants.SHAPE_USER_WARNING;
  } else if (it.status === BreakoutClientStatus.LEFT) {
    if (!finished) {
      status = constants.TEXT_USER_STATUS_PROBLEM;
      shape = constants.SHAPE_USER_ERROR;
    }
  }

  return { shape: cloneShapeStyle(shape), status: status };
}

function upsertGroupCollection(
  breakoutController: BreakoutController,
  type: 'ready' | 'started' | 'empty' | 'finished' | 'not_started',
  collectionData: { count: number; users: number },
  y,
): number {
  let collectionIndex = breakoutController.collectionListItems.findIndex((it) => it.type === type);
  let collection: CollectionListItem =
    collectionIndex >= 0 ? breakoutController.collectionListItems[collectionIndex] : null;
  if (collectionData && collectionData.count > 0) {
    if (collectionIndex < 0) {
      collection = createGroupCollection(breakoutController.manager, type, collectionData);
      collection.container.moveMode = MoveMode.ANCHORED;
      breakoutController.collectionListItems.push(collection);
      breakoutController.groupCanvas.attachChild(
        collection.container,
        breakoutController.groupCanvas,
      );
    } else {
      updateGroupCollection(collection, collectionData);
    }
    collection.container.anchoredPos = anchoredPos(v2(0, 0), v2(5, y), v2(0, 0));

    return collection.container.height;
  } else if ((!collectionData || collectionData.count === 0) && collectionIndex >= 0) {
    setVisibilityState(collection.container, VisibilityState.DISAPPEARING);
    removeDenseArrayIndex(breakoutController.collectionListItems, collectionIndex);
    return 0;
  }
  return 0;
}

function upsertBreakoutListItem(
  breakoutController: BreakoutController,
  groupData: BreakoutGroupData,
  y: number,
): number {
  let groupIndex = breakoutController.groupListItems.findIndex((it) => it.id === groupData.groupId);
  let group: GroupListItem = groupIndex >= 0 ? breakoutController.groupListItems[groupIndex] : null;
  if (groupData) {
    if (groupIndex < 0) {
      group = createBreakoutListItem(breakoutController.manager, groupData);
      group.container.moveMode = MoveMode.ANCHORED;
      breakoutController.groupListItems.push(group);
      breakoutController.groupCanvas.attachChild(group.container, breakoutController.groupCanvas);
    }
    updateBreakoutListItem(group, groupData, breakoutController.totalMissionSteps);

    group.container.anchoredPos = anchoredPos(v2(0, 0), v2(5, y), v2(0, 0));

    return group.container.height;
  }
  return 0;
}

function updateBreakoutListItem(group: GroupListItem, data: BreakoutGroupData, totalSteps: number) {
  const status = data.status;
  let statusText = '';

  if (data.isFinished) {
    statusText = 'Finished';
  } else if (data.started) {
    if (status === BreakoutGroupStatus.START_LOBBY) {
      statusText = 'Paused in start lobby';
    } else if (status === BreakoutGroupStatus.LOBBY) {
      statusText = 'Paused in lobby';
    } else {
      statusText = 'Active';
    }
  } else if (data.isReady) {
    statusText = 'Ready';
  } else {
    statusText = 'Not Ready';
  }

  let stepText = '';

  if (data.isFinished) {
    stepText = `Finished`;
  } else if (data.started && data.activeStep) {
    let roundText = '';
    if (data.activeRound) {
      roundText = ` round ${data.activeRound}`;
    }
    stepText = ` step ${data.activeStep}/${totalSteps}${roundText}`;
  }

  const isWarning = data.started && data.status === BreakoutGroupStatus.LOBBY;

  if (!data.started && !data.isReady && !data.isFinished) {
    setContainerStyle(group.statusBar, constants.SHAPE_STATUS_ERROR);
    setContainerStyles(group.container, constants.SHAPE_GROUP_ERROR, constants.SHAPE_GROUP_ERROR_HL);
  } else {
    if (data.isFinished) {
      setContainerStyle(group.statusBar, constants.SHAPE_STATUS_ACTIVE);
      setContainerStyles(group.container, constants.SHAPE_GROUP_ACTIVE, constants.SHAPE_GROUP_ACTIVE_HL);
    } else if (isWarning) {
      setContainerStyle(group.statusBar, constants.SHAPE_STATUS_WARNING);
      setContainerStyles(group.container, constants.SHAPE_GROUP_WARNING, constants.SHAPE_GROUP_WARNING_HL);
    } else if (data.started) {
      setContainerStyle(group.statusBar, constants.SHAPE_STATUS_ACTIVE);
      setContainerStyles(group.container, constants.SHAPE_GROUP_ACTIVE, constants.SHAPE_GROUP_ACTIVE_HL);
    } else {
      setContainerStyle(group.statusBar, SHAPE_STYLES.NONE);
      setContainerStyles(group.container, constants.SHAPE_GROUP_DEFAULT, constants.SHAPE_GROUP_DEFAULT_HL);
    }
  }

  const MARGIN = 8;
  let posY = MARGIN;

  changeTextObjectText(group.tObjStep, stepText);
  changeTextObjectText(group.tObjStatus, statusText);

  posY += group.tObjStatus.height + MARGIN;

  changeTextObjectText(group.tObjUserGroup, data.userGroupName);

  if (!data.userGroupName) {
    if (hasVisibleState(group.tObjUserGroup.visibilityState)) {
      setVisibilityState(group.tObjUserGroup, VisibilityState.HIDDEN);
    }
    posY += MARGIN;
  } else {
    if (!hasVisibleState(group.tObjUserGroup.visibilityState)) {
      setVisibilityState(group.tObjUserGroup, VisibilityState.DEFAULT);
    }
    group.tObjUserGroup.anchoredPos.offset.y = posY;
    posY += group.tObjUserGroup.height + MARGIN;
  }

  if (stepText.length) {
    setVisibilityState(group.tObjStep, VisibilityState.DEFAULT);
  } else {
    setVisibilityState(group.tObjStep, VisibilityState.HIDDEN);
  }

  const manager = group.container.manager;

  for (let i = 0; i < data.clients.length; i++) {
    const userData = data.clients[i];

    let userView: BreakoutUserView = group.userViews.find((it) => it.id === userData.id);

    if (!userView) {
      userView = createBreakoutUserView(manager, userData);
      group.userViews.push(userView);
      setParent(userView.container, group.container);
    }

    updateUserView(userView, userData, posY, group.data.started, group.data.isFinished);
    posY += userView.container.height + MARGIN;
  }
  //remove userViews that do not exist anymore
  for (let i = group.userViews.length - 1; i >= 0; i--) {
    const id = group.userViews[i].id;
    const idExists = data.clients.find((it) => it.id === id);
    if (!idExists) {
      setVisibilityState(group.userViews[i].container, VisibilityState.DISAPPEARING);
      removeDenseArrayIndex(group.userViews, i);
    }
  }

  posY += MARGIN;

  group.data = data;

  posY += MARGIN;
  group.container.height = Math.max(constants.MIN_GROUP_HEIGHT, posY);

  if (group.container.highlighted) {
    highlightGroup(group);
  }
}

function updateUserView(
  view: BreakoutUserView,
  baUser: BreakoutUser,
  y: number,
  started: boolean,
  finished: boolean,
) {
  if (!view) return;

  changeTextObjectText(view.tObjName, baUser.name);

  const statusText = getUserStatusString(baUser, started, finished);
  const { shape, status } = getUserViewStyle(baUser, started, finished);

  setContainerStyles(view.container, shape, { ...shape, strokeWeight: 5 });

  if (statusText) {
    if (!view.tObjStatus) {
      view.tObjStatus = createAndAddLocalTextObject(
        view.container.manager,
        getZeroStaticEntity(),
        statusText,
        noAutoResize(status),
        0,
        false,
        1,
        0,
        TextAppearStyle.FADE,
      );

      view.tObjStatus.moveMode = MoveMode.ANCHORED;
      view.tObjStatus.passHover = true;
      view.tObjStatus.allowHighlight = false;

      setParent(view.tObjStatus, view.container);
    } else {
      view.tObjStatus.textStyle = status;
      changeTextObjectText(view.tObjStatus, statusText);
    }
  } else {
    if (view.tObjStatus) {
      setVisibilityState(view.tObjStatus, VisibilityState.DISAPPEARING);
      view.tObjStatus = null;
    }
  }

  if (view.tObjStatus) {
    if (view.tObjName.width < 200) {
      view.tObjStatus.anchoredPos = anchoredPos(v2(1, 1), v2(-5, -5), v2(1, 1));
      view.container.width = view.tObjName.width + view.tObjStatus.width;
      view.container.height = view.tObjName.height;
    } else {
      view.tObjStatus.anchoredPos = anchoredPos(v2(1, 1), v2(-5, -2), v2(1, 1));
      view.container.width = view.tObjName.width;
      view.container.height = view.tObjName.height + view.tObjStatus.height;
    }
  } else {
    view.container.width = view.tObjName.width;
    view.container.height = view.tObjName.height;
  }

  view.container.anchoredPos.offset.y = y;
}

function highlightGroup(group: GroupListItem) {
  const data = group.data;
  const canContinue =
    data.started && data.clients.some((it) => it.status === BreakoutClientStatus.IN_PLENARY);
  const manager = group.container.manager;

  const MARGIN_X = -5;
  let marginY = 40;
  const BUTTON_PADDING_Y = 8;

  if (data.isReady && !data.started && !data.isFinished) {
    if (!group.btnStart) {
      group.btnStart = createStartButton(manager, MARGIN_X, marginY);
      setParent(group.btnStart, group.container);
    }
    group.btnStart.anchoredPos.offset.y = marginY;
    marginY += group.btnStart.height + BUTTON_PADDING_Y;
  } else if (group.btnStart) {
    setVisibilityState(group.btnStart, VisibilityState.DISAPPEARING);
    group.btnStart = null;
  }

  if (canContinue) {
    if (!group.btnContinue) {
      group.btnContinue = createContinueButton(manager, MARGIN_X, marginY);
      setParent(group.btnContinue, group.container);
    }
    group.btnContinue.anchoredPos.offset.y = marginY;
    marginY += group.btnContinue.height + BUTTON_PADDING_Y;
  } else if (group.btnContinue) {
    setVisibilityState(group.btnContinue, VisibilityState.DISAPPEARING);
    group.btnContinue = null;
  }

  if (!data.started && !data.isFinished) {
    if (!group.btnUngroup) {
      group.btnUngroup = createUngroupButton(manager, MARGIN_X, marginY);
      setParent(group.btnUngroup, group.container);
    }
    group.btnUngroup.anchoredPos.offset.y = marginY;
    marginY += group.btnUngroup.height + BUTTON_PADDING_Y;
  } else if (group.btnUngroup) {
    setVisibilityState(group.btnUngroup, VisibilityState.DISAPPEARING);
    group.btnUngroup = null;
  }

  if (data.started) {
    if (!group.btnStop) {
      group.btnStop = createStopButton(manager, MARGIN_X, marginY);
      setParent(group.btnStop, group.container);
    }
    marginY += group.btnStop.height + BUTTON_PADDING_Y;
  } else if (group.btnStop) {
    setVisibilityState(group.btnStop, VisibilityState.DISAPPEARING);
    group.btnStop = null;
  }

  if (data.canJoin) {
    if (!group.btnJoin) {
      group.btnJoin = createJoinButton(manager, MARGIN_X, marginY);
      setParent(group.btnJoin, group.container);
    }
    group.btnJoin.anchoredPos.offset.y = marginY;
    marginY += group.btnJoin.height + BUTTON_PADDING_Y;
  } else if (group.btnJoin) {
    setVisibilityState(group.btnJoin, VisibilityState.DISAPPEARING);
    group.btnJoin = null;
  }

  if (data.canLeave) {
    if (!group.btnLeave) {
      group.btnLeave = createLeaveButton(manager, MARGIN_X, marginY);
      setParent(group.btnLeave, group.container);
    }
    group.btnLeave.anchoredPos.offset.y = marginY;
    marginY += group.btnLeave.height + BUTTON_PADDING_Y;
  } else if (group.btnLeave) {
    setVisibilityState(group.btnLeave, VisibilityState.DISAPPEARING);
    group.btnLeave = null;
  }
}

function stopHighlightGroup(group: GroupListItem) {
  if (group.btnJoin) {
    setVisibilityState(group.btnJoin, VisibilityState.DISAPPEARING);
    group.btnJoin = null;
  }
  if (group.btnLeave) {
    setVisibilityState(group.btnLeave, VisibilityState.DISAPPEARING);
    group.btnLeave = null;
  }
  if (group.btnStop) {
    setVisibilityState(group.btnStop, VisibilityState.DISAPPEARING);
    group.btnStop = null;
  }

  if (group.btnUngroup) {
    setVisibilityState(group.btnUngroup, VisibilityState.DISAPPEARING);
    group.btnUngroup = null;
  }
  if (group.btnContinue) {
    setVisibilityState(group.btnContinue, VisibilityState.DISAPPEARING);
    group.btnContinue = null;
  }
  if (group.btnStart) {
    setVisibilityState(group.btnStart, VisibilityState.DISAPPEARING);
    group.btnStart = null;
  }
}

function createStartButton(manager: GameManager, x: number, y: number): TextButton {
  const btn = createAndAddLocalTextButton(
    manager,
    getZeroStaticEntity({ disableAutoSize: true }),
    'Start',
    'iconPlay',
    TEXT_STYLE.BUTTON_FIXED_GREEN,
  );

  btn.moveMode = MoveMode.ANCHORED;
  btn.passHover = true;
  btn.appearDuration = 0.1;
  btn.textObject.appearDuration = 0.1;
  btn.disappearDuration = 0.1;

  btn.anchoredPos = anchoredPos(v2(1, 0), v2(x, y), v2(1, 0));

  setVisibilityState(btn, VisibilityState.APPEARING);

  return btn;
}

function createContinueButton(manager: GameManager, x: number, y: number): TextButton {
  const btn = createAndAddLocalTextButton(
    manager,
    getZeroStaticEntity({ disableAutoSize: true }),
    'Continue',
    'iconPlay',
    TEXT_STYLE.BUTTON_FIXED_GREEN,
  );

  btn.moveMode = MoveMode.ANCHORED;
  btn.passHover = true;
  btn.appearDuration = 0.1;
  btn.textObject.appearDuration = 0.1;
  btn.disappearDuration = 0.1;

  btn.anchoredPos = anchoredPos(v2(1, 0), v2(x, y), v2(1, 0));

  setVisibilityState(btn, VisibilityState.APPEARING);

  return btn;
}

function createUngroupButton(manager: GameManager, x: number, y: number): TextButton {
  const btn = createAndAddLocalTextButton(
    manager,
    getZeroStaticEntity({ disableAutoSize: true }),
    'Ungroup',
    'iconQuit',
    TEXT_STYLE.BUTTON_FIXED_BLUE,
  );

  btn.moveMode = MoveMode.ANCHORED;
  btn.passHover = true;
  btn.appearDuration = 0.1;
  btn.textObject.appearDuration = 0.1;
  btn.disappearDuration = 0.1;

  btn.anchoredPos = anchoredPos(v2(1, 0), v2(x, y), v2(1, 0));

  setVisibilityState(btn, VisibilityState.APPEARING);

  return btn;
}

function createStopButton(manager: GameManager, x: number, y: number): TextButton {
  const btn = createAndAddLocalTextButton(
    manager,
    getZeroStaticEntity({ disableAutoSize: true }),
    'Stop',
    'iconQuit',
    TEXT_STYLE.BUTTON_FIXED_RED_DARK,
    0,
    0,
    2,
  );

  btn.moveMode = MoveMode.ANCHORED;
  btn.passHover = true;
  btn.appearDuration = 0.1;
  btn.textObject.appearDuration = 0.1;
  btn.disappearDuration = 0.1;

  btn.anchoredPos = anchoredPos(v2(1, 0), v2(x, y), v2(1, 0));

  setVisibilityState(btn, VisibilityState.APPEARING);

  return btn;
}

function createJoinButton(manager: GameManager, x: number, y: number): TextButton {
  const btn = createAndAddLocalTextButton(
    manager,
    getZeroStaticEntity({ disableAutoSize: true }),
    'Join',
    '',
    TEXT_STYLE.BUTTON_FIXED_BLUE,
  );

  btn.moveMode = MoveMode.ANCHORED;
  btn.passHover = true;
  btn.appearDuration = 0.1;
  btn.textObject.appearDuration = 0.1;
  btn.disappearDuration = 0.1;

  btn.anchoredPos = anchoredPos(v2(1, 0), v2(x, y), v2(1, 0));

  setVisibilityState(btn, VisibilityState.APPEARING);

  return btn;
}

function createLeaveButton(manager: GameManager, x: number, y: number): TextButton {
  const btn = createAndAddLocalTextButton(
    manager,
    getZeroStaticEntity({ disableAutoSize: true }),
    'Leave',
    '',
    TEXT_STYLE.BUTTON_FIXED_BLUE,
  );

  btn.moveMode = MoveMode.ANCHORED;
  btn.passHover = true;
  btn.appearDuration = 0.1;
  btn.textObject.appearDuration = 0.1;
  btn.disappearDuration = 0.1;

  btn.anchoredPos = anchoredPos(v2(1, 0), v2(x, y), v2(1, 0));

  setVisibilityState(btn, VisibilityState.APPEARING);

  return btn;
}

function createBreakoutUserView(manager: GameManager, data: BreakoutUser): BreakoutUserView {
  //container
  const c = createAndAddLocalContainer(manager, getZeroStaticEntity());
  c.width = constants.WIDTH;
  c.height = constants.HEIGHT;
  c.allowHighlight = true;
  c.passHover = true;
  c.allowDrag = false;
  c.clickable = true;
  c.passDrag = true;
  c.cornerRadius = 20;
  setContainerStyle(c, SHAPE_STYLES.BREAKOUT_CONTROLLER.BACKGROUND);
  c.moveMode = MoveMode.ANCHORED;
  c.anchoredPos = anchoredPos(v2(0, 0), v2(20, 0), v2(0, 0));

  const tObjName = createAndAddLocalTextObject(
    manager,
    getZeroStaticEntity(),
    data.name,
    constants.TEXT_USER_NAME,
    3.5,
    false,
  );

  tObjName.moveMode = MoveMode.ANCHORED;
  tObjName.appearDuration = 0;
  tObjName.disappearDuration = 0;
  tObjName.allowHighlight = false;

  tObjName.anchoredPos = anchoredPos(v2(0, 0), v2(0, 0), v2(0, 0));

  setParent(tObjName, c);

  c.width = tObjName.width;
  c.height = tObjName.height;

  const result: BreakoutUserView = {
    id: data.id,
    container: c,
    tObjName,
    tObjStatus: null,
    btnRemove: null,
    btnAdd: null,
  };

  return result;
}

function updateGroupListItem(group: GroupListItem): JSON_BreakoutGroupAction {
  if (group.container.startHighlightThisFrame) {
    highlightGroup(group);
  } else if (group.container.stopHighlightThisFrame) {
    stopHighlightGroup(group);
  }

  let actionData: JSON_BreakoutGroupAction = null;

  if (group.btnStart?.clickedThisFrame) {
    actionData = {
      sId: -1,
      groupId: group.data.groupId,
      action: 'start',
    };
  } else if (group.btnContinue?.clickedThisFrame) {
    actionData = {
      sId: -1,
      groupId: group.data.groupId,
      action: 'continue',
    };
  } else if (group.btnStop?.executeThisFrame) {
    actionData = {
      sId: -1,
      groupId: group.data.groupId,
      action: 'stop',
    };
  } else if (group.btnUngroup?.executeThisFrame) {
    actionData = {
      sId: -1,
      groupId: group.data.groupId,
      action: 'ungroup',
    };
  } else if (group.btnJoin?.clickedThisFrame) {
    actionData = {
      sId: -1,
      groupId: group.data.groupId,
      action: 'join',
    };
  } else if (group.btnLeave?.clickedThisFrame) {
    actionData = {
      sId: -1,
      groupId: group.data.groupId,
      action: 'leave',
    };
  } else {
    for (let i = group.userViews.length - 1; i >= 0; i--) {
      const userView = group.userViews[i];
      const isGroupStarted = group.data.started;
      const isGroupFinished = group.data.isFinished;
      actionData = updateUserViews(userView, true, isGroupStarted, isGroupFinished);
      if (actionData) {
        actionData.groupId = group.id;
        break;
      }
    }
  }

  return actionData;
}

function updateUserViews(
  userView: BreakoutUserView,
  userIsInGroup: boolean,
  isGroupStarted: boolean,
  isGroupFinished: boolean,
): JSON_BreakoutGroupAction {
  if (userView.container.startHighlightThisFrame) {
    if (userIsInGroup && !isGroupStarted && !isGroupFinished && !userView.btnRemove) {
      userView.btnRemove = createBtnRemove(userView);
      setParent(userView.btnRemove, userView.container);
    } else if (!userIsInGroup && !userView.btnAdd) {
      userView.btnAdd = createBtnAdd(userView);
      setParent(userView.btnAdd, userView.container);
    }
  } else if (userView.container.stopHighlightThisFrame) {
    if (userView.btnRemove) {
      setVisibilityState(userView.btnRemove, VisibilityState.DISAPPEARING);
      userView.btnRemove = null;
    }
    if (userView.btnAdd) {
      setVisibilityState(userView.btnAdd, VisibilityState.DISAPPEARING);
      userView.btnAdd = null;
    }
  }

  let actionData: JSON_BreakoutGroupAction = null;

  if (userView.btnRemove?.clickedThisFrame) {
    actionData = {
      sId: -1,
      groupId: -1,
      baClientId: userView.id,
      action: 'removeUserFromGroup',
    };
  } else if (userView.btnAdd?.clickedThisFrame) {
    actionData = {
      sId: -1,
      groupId: -1,
      baClientId: userView.id,
      action: 'addUserToGroup',
    };
  }

  return actionData;
}

function createBtnRemove(userView: BreakoutUserView): IconButton {
  const manager = userView.container.manager;
  const btn = createAndAddLocalIconButton(manager, constants.BUTTON_REMOVE_USER);
  btn.passHover = true;
  btn.moveMode = MoveMode.ANCHORED;
  btn.hoverMoveStrength = 0;
  btn.hoverGrowStrength = 1;
  btn.anchoredPos = anchoredPos(v2(1, 0.5), v2(0, 0), v2(1, 0.5));
  return btn;
}

function createBtnAdd(userView: BreakoutUserView): IconButton {
  const manager = userView.container.manager;
  const btn = createAndAddLocalIconButton(manager, constants.BUTTON_ADD_USER);
  btn.passHover = true;
  btn.moveMode = MoveMode.ANCHORED;
  btn.hoverMoveStrength = 0;
  btn.hoverGrowStrength = 1;
  btn.anchoredPos = anchoredPos(v2(1, 0.5), v2(0, 0), v2(1, 0.5));
  return btn;
}

function setLobbyState(baController: BreakoutController, lobbyState: BreakoutLobbyState) {
  {
    const { style, hover } = getStateButtonStyle(lobbyState === BreakoutLobbyState.PRE_OPEN);
    setTextbuttonStyle(baController.btnState_preOpen, style, hover);
  }

  {
    const { style, hover } = getStateButtonStyle(lobbyState === BreakoutLobbyState.MATCHING);
    setTextbuttonStyle(baController.btnState_Matching, style, hover);
  }

  {
    const { style, hover } = getStateButtonStyle(lobbyState === BreakoutLobbyState.CLOSED);
    setTextbuttonStyle(baController.btnState_Closed, style, hover);
  }

  {
    const { style, hover } = getStateButtonStyle(lobbyState === BreakoutLobbyState.CLOSED_PROBLEM);
    setTextbuttonStyle(baController.btnState_Closed_Problem, style, hover);
  }
}

function getStateButtonStyle(selected: boolean): {
  style: RenderShapeStyle;
  hover: RenderShapeStyle;
} {
  const style = selected ? constants.SHAPE_BTN_SELECTED : constants.SHAPE_BTN_DEFAULT;
  const hover = selected ? constants.SHAPE_BTN_SELECTED : constants.SHAPE_BTN_DEFAULT_HL;

  return { style, hover };
}

function checkButtonInteraction(breakoutController: BreakoutController): JSON_BreakoutGroupAction {
  let action: string = '';

  if (breakoutController.btnStartAllReady?.clickedThisFrame) {
    action = 'start_all_ready';
  } else if (breakoutController.btnState_preOpen?.clickedThisFrame) {
    action = 'state-pre-open';
  } else if (breakoutController.btnState_Matching?.clickedThisFrame) {
    action = 'state-matching';
  } else if (breakoutController.btnState_Closed?.clickedThisFrame) {
    action = 'state-closed';
  } else if (breakoutController.btnState_Closed_Problem?.clickedThisFrame) {
    action = 'state-closed-problem';
  } else if (breakoutController.btnStopAll?.executeThisFrame) {
    action = 'stop_all';
  } else if (breakoutController.btnStopAllTimed?.executeThisFrame) {
    action = 'stop_all_timed';
  } else if (breakoutController.btnCreateGroups?.clickedThisFrame) {
    action = 'create_groups';
  }

  if (action.length) {
    const data: JSON_BreakoutGroupAction = {
      sId: breakoutController.serverObjId,
      groupId: 0,
      action,
    };
    return data;
  }

  return null;
}

function sortGroupData(a: BreakoutGroupData, b: BreakoutGroupData): number {
  const isWarningA = a.started && a.status === BreakoutGroupStatus.LOBBY;
  const isWarningB = b.started && b.status === BreakoutGroupStatus.LOBBY;

  if (isWarningA !== isWarningB) {
    if (isWarningA) return -1;
    if (isWarningB) return 1;
  }

  return 0;
}
